<template>
  <DropdownMenu
    ref="dropdownRef"
    as="div"
    button-class="btn btn-outline btn-sm"
    content-class="bg-base-100 rounded-box p-4 shadow-lg w-80 border mt-1 border-base-300"
    :title="title"
  >
    <template #trigger>
      {{ title }}
      <span
        v-if="activeFilterCount > 0"
        class="badge badge-sm badge-neutral ml-2"
        >{{ activeFilterCount }}</span
      >
    </template>

    <form @submit.prevent="applyFilters">
      <slot></slot>

      <div class="flex justify-between mt-4">
        <button
          type="button"
          @click="resetFilters"
          class="btn btn-sm btn-ghost"
        >
          Išvalyti
        </button>
        <button type="submit" class="btn btn-sm btn-primary">Taikyti</button>
      </div>
    </form>
  </DropdownMenu>
</template>

<script setup>
import { computed, ref, watch, defineProps, defineEmits } from "vue";
import { useRouter, useRoute } from "vue-router";
import DropdownMenu from "../ui/menu/DropdownMenu.vue";

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
  title: {
    type: String,
    default: "Filters",
  },
});

const emit = defineEmits(["update:modelValue"]);
const router = useRouter();
const route = useRoute();
const dropdownRef = ref(null);

// Count active filters
const activeFilterCount = computed(() => {
  return Object.values(props.modelValue).filter((value) => value).length;
});

// Apply filters
const applyFilters = () => {
  // Create query with current filter values
  const query = { page: "1" };

  // Add non-empty filter values
  for (const [key, value] of Object.entries(props.modelValue)) {
    if (value) query[key] = value;
  }

  // Update URL with new query parameters
  router.push({ query });
  dropdownRef.value.close();
};

// Reset filters
const resetFilters = () => {
  // Create empty filters object
  const emptyFilters = {};

  // Set all properties to empty strings
  for (const key of Object.keys(props.modelValue)) {
    emptyFilters[key] = "";
  }

  // Update the model value
  emit("update:modelValue", emptyFilters);

  // Apply empty filters immediately
  router.push({ query: { page: "1" } });
  dropdownRef.value.close();
};

// Initialize from URL on route change
watch(
  route,
  () => {
    // Create a new filters object
    const newFilters = { ...props.modelValue };

    // Update from URL query parameters
    for (const key of Object.keys(newFilters)) {
      if (key in route.query) {
        newFilters[key] = route.query[key];
      }
    }

    // Update the model
    emit("update:modelValue", newFilters);
  },
  { immediate: true },
);
</script>
